<template>
  <page-resolver v-bind="{ ...$props, ...$attrs }">
    <template v-slot:failed>
      <not-found />
    </template>
  </page-resolver>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import NotFound from '@/components/views/NotFound.vue'
import PageResolver from '@/components/resolvers/PageResolver.vue'
import { resolversBaseProps } from '@/composition/resolvers'

export default defineComponent({
  components: { PageResolver, NotFound },
  inheritAttrs: false,
  props: {
    ...resolversBaseProps,
  },
})
</script>
